import { render, staticRenderFns } from "./vehicle-infos.vue?vue&type=template&id=52018b2b&scoped=true&"
import script from "./vehicle-infos.vue?vue&type=script&lang=js&"
export * from "./vehicle-infos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52018b2b",
  null
  
)

export default component.exports